import { FC } from 'react'
import { Snackbar, Alert } from '@mui/material'

interface NoResultsAlertProps {
  open: boolean
  onClose: () => void
}

export const NoResultsAlert: FC<NoResultsAlertProps> = ({ open, onClose }) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={3000}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      sx={{
        marginBottom: '20px',
        marginRight: '20px',
        position: 'fixed',
        zIndex: 1500, // Increased z-index to appear above drawer (1200)
        '& .MuiSnackbar-root': {
          position: 'fixed',
          zIndex: 1500,
        },
      }}
    >
      <Alert
        onClose={onClose}
        severity="error" // Changed from info to error for red styling
        variant="filled"
        sx={{
          width: '100%',
          backgroundColor: '#FF2D2D', // Changed from '#255' to '#FF2D2D'
          fontFamily: 'Gabarito',
          '& .MuiAlert-message': {
            fontSize: '14px',
          },
        }}
      >
        No results found for the current filters
      </Alert>
    </Snackbar>
  )
}
